import styled, { keyframes } from 'styled-components'

const spinnerAnimation = keyframes`
 0% { transform: rotate(0deg); }
 100% { transform: rotate(360deg); }
`

export const SpinnerContainer = styled.div<{ isLoading: boolean }>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: ${(props) => (props.isLoading ? 'auto' : 'none')};
  z-index: 1;
`

export const LoadingSpinner = styled.div`
  width: 50px;
  height: 50px;
  border: 10px solid #f3f3f3; /* Light grey */
  border-top: 10px solid #c00000; /* Black */
  border-radius: 50%;
  animation: ${spinnerAnimation} 1s linear infinite;
`
